/**
 * Convierte markdown simple a HTML para el editor de texto enriquecido
 * Soporta: **negrita**, *cursiva*, # títulos, listas, etc.
 */
export const markdownToHtml = (markdown: string): string => {
  if (!markdown) return '';

  let html = markdown;

  // Títulos (# ## ###)
  html = html.replace(/^### (.*$)/gim, '<h3>$1</h3>');
  html = html.replace(/^## (.*$)/gim, '<h2>$1</h2>');
  html = html.replace(/^# (.*$)/gim, '<h1>$1</h1>');

  // Negrita (**texto** o __texto__)
  html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/__(.*?)__/g, '<strong>$1</strong>');

  // Cursiva (*texto* o _texto_)
  html = html.replace(/\*(.*?)\*/g, '<em>$1</em>');
  html = html.replace(/_(.*?)_/g, '<em>$1</em>');

  // Listas con viñetas (- item o * item)
  html = html.replace(/^- (.*$)/gim, '<li>$1</li>');
  html = html.replace(/^\* (.*$)/gim, '<li>$1</li>');
  html = html.replace(/(<li>.*<\/li>)/s, '<ul>$1</ul>');

  // Listas numeradas (1. item)
  html = html.replace(/^\d+\.\s+(.*$)/gim, '<li>$1</li>');

  // Blockquotes (> texto)
  html = html.replace(/^> (.*$)/gim, '<blockquote>$1</blockquote>');

  // Código inline (`código`)
  html = html.replace(/`([^`]+)`/g, '<code>$1</code>');

  // Saltos de línea
  html = html.replace(/\n\n/g, '</p><p>');
  html = html.replace(/\n/g, '<br>');

  // Envolver en párrafo si no hay tags de bloque
  if (!html.includes('<h1>') && !html.includes('<h2>') && !html.includes('<h3>') && !html.includes('<ul>') && !html.includes('<ol>')) {
    html = `<p>${html}</p>`;
  }

  return html;
};

/**
 * Convierte HTML a markdown simple (para guardar)
 * Esto es opcional si queremos mantener el formato original
 */
export const htmlToMarkdown = (html: string): string => {
  if (!html) return '';

  let markdown = html;

  // Títulos
  markdown = markdown.replace(/<h1>(.*?)<\/h1>/gi, '# $1\n\n');
  markdown = markdown.replace(/<h2>(.*?)<\/h2>/gi, '## $1\n\n');
  markdown = markdown.replace(/<h3>(.*?)<\/h3>/gi, '### $1\n\n');

  // Negrita
  markdown = markdown.replace(/<strong>(.*?)<\/strong>/gi, '**$1**');
  markdown = markdown.replace(/<b>(.*?)<\/b>/gi, '**$1**');

  // Cursiva
  markdown = markdown.replace(/<em>(.*?)<\/em>/gi, '*$1*');
  markdown = markdown.replace(/<i>(.*?)<\/i>/gi, '*$1*');

  // Listas
  markdown = markdown.replace(/<li>(.*?)<\/li>/gi, '- $1\n');
  markdown = markdown.replace(/<ul>/gi, '\n');
  markdown = markdown.replace(/<\/ul>/gi, '\n');
  markdown = markdown.replace(/<ol>/gi, '\n');
  markdown = markdown.replace(/<\/ol>/gi, '\n');

  // Blockquotes
  markdown = markdown.replace(/<blockquote>(.*?)<\/blockquote>/gi, '> $1\n\n');

  // Código
  markdown = markdown.replace(/<code>(.*?)<\/code>/gi, '`$1`');

  // Párrafos y saltos de línea
  markdown = markdown.replace(/<\/p>/gi, '\n\n');
  markdown = markdown.replace(/<p>/gi, '');
  markdown = markdown.replace(/<br\s*\/?>/gi, '\n');

  // Limpiar tags HTML restantes
  markdown = markdown.replace(/<[^>]+>/g, '');

  // Limpiar espacios múltiples
  markdown = markdown.replace(/\n{3,}/g, '\n\n');

  return markdown.trim();
};

